import { Injectable } from '@angular/core';
import { LocalNotifications, ScheduleEvery } from '@capacitor/local-notifications';

@Injectable({
	providedIn: 'root',
})
export class LocalNotificationsService {

	private readonly notificationId: number = 77;

	constructor() { }

	public permission() {
		LocalNotifications.requestPermissions();
	}

	public notification(
		body: string,
		title: string = 'Shift Reminder',
		count: number
	) {
		const at = new Date();
		let every: ScheduleEvery;
		every = 'minute';
		at.setMinutes(at.getMinutes() + (60 * count));

		LocalNotifications
			.schedule({
				notifications: [
					{
						id: this.notificationId,
						title,
						body,
						schedule: {
							at,
							every,
							repeats: true,
							count
						}
					}
				]
			});
	}

	public cancelNotifications(): Promise<any> {
		LocalNotifications.cancel({ notifications: [{ id: this.notificationId }] });
		// Reinforced attempt
		return LocalNotifications
			.getPending()
			.then(pending => {
				pending.notifications?.forEach(notification => {
					LocalNotifications.cancel({ notifications: [{ id: notification?.id }] });
				});
				// Reinforced attempt
				if (!pending?.notifications?.length) {
					return;
				}
				LocalNotifications.cancel(pending);
			});
	}

	public requestPermission() {
		LocalNotifications.requestPermissions()
	}
}
